import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100vw",
      height: "auto",
      // overflow: 'hidden',
    },
    container: {
      [theme.breakpoints.down("xs")]: {
        paddingLeft: theme.spacing(1),
        paddingRieght: theme.spacing(1),
      },
    },
  })
);
